import get from 'lodash/get';
import has from 'lodash/has';
import keyBy from 'lodash/keyBy';

import { FacilityType } from '../../../../services/admin';

export const FILTER_STORAGE_KEY = 'facility-grid-filter-model';
const getSessionFilters = () => {
  try {
    const storedFilters = sessionStorage.getItem(FILTER_STORAGE_KEY);
    const parsedFilters = JSON.parse(storedFilters || '{}');
    return parsedFilters?.items ?? [];
  } catch (e) {
    return [];
  }
};
export const buildInitialFiltersFactory = (
  searchParams: URLSearchParams,
  config: {
    fromUrl?: boolean;
    fromSession?: boolean;
  }
) => {
  type ParamsType = {
    facilityName: string;
    addedToSaas: boolean;
    isUsingMobile: boolean;
    isUsingSaasAuthentication: boolean;
    isUsingSbvPro: boolean;
  };

  const items: {
    id: string | number;
    value: any;
    field: keyof FacilityType;
    operator: string;
  }[] = [];

  const itemsByKey = keyBy(getSessionFilters(), 'field');

  const addFilter = (
    paramKey: keyof ParamsType,
    fieldName: keyof FacilityType,
    operator: string,
    valueParser: (v: string | null) => any
  ) => {
    if (searchParams.has(paramKey) && config.fromUrl) {
      items.push({
        id: fieldName,
        value: valueParser(searchParams.get(paramKey)),
        field: fieldName,
        operator,
      });
    }
    if (has(itemsByKey, fieldName) && config.fromSession) {
      items.push({
        id: fieldName,
        value: get(itemsByKey, [fieldName, 'value']),
        field: fieldName,
        operator,
      });
    }
  };

  const factory = {
    addStringFilter(
      paramKey: keyof ParamsType,
      fieldName: keyof FacilityType,
      operator: string = 'contains'
    ) {
      addFilter(paramKey, fieldName, operator, (v) => v);
      return factory;
    },
    addBooleanFilter(
      paramKey: keyof ParamsType,
      fieldName: keyof FacilityType,
      operator: string = 'is'
    ) {
      addFilter(paramKey, fieldName, operator, (v) => v === 'true');
      return factory;
    },
    build() {
      return items;
    },
  };

  return factory;
};
